import { useFocusRestoration, useGlobalState } from '@/hooks';
import { PmtSignUpStep } from '@/interfaces/tracking';
import { useEmailSyncContext, useMyParcelsContext, usePopUpsContext } from '@/modules/pmt/context';
import { PmtOnboardingPopupVariant } from '../../interfaces/tracking/trackingOnboardingPopup.interfaces';
import { PopupComponentMapping } from './components/Popups';
import { TwoPanelCenter } from './components/Popups/TwoPanelCenter';
import { usePmtOnboardingPopupCopy } from './hooks';

export const TrackingOnboardingPopup = () => {
  const { pmtSignUpStep, showPMTPopUp } = useGlobalState();
  const { pmtOnboardingPopUp, pmtEmailSyncOnboardingPopUp } = useMyParcelsContext();
  const { isEmailSyncAllowed } = useEmailSyncContext();
  const { onCloseOnboardingPopUp, onboardingPopUpDelayTime } = usePopUpsContext();
  const enrichedPmtOnboardingPopUp = usePmtOnboardingPopupCopy(pmtOnboardingPopUp);
  const enrichedPmtEmailSyncOnboardingPopUp = usePmtOnboardingPopupCopy(pmtEmailSyncOnboardingPopUp);

  useFocusRestoration(showPMTPopUp);

  const popUp = isEmailSyncAllowed ? enrichedPmtEmailSyncOnboardingPopUp : enrichedPmtOnboardingPopUp;
  if (!popUp) return null;

  const { variant } = popUp;

  const renderPopup = () => {
    if (isEmailSyncAllowed && pmtSignUpStep === PmtSignUpStep.SignUp) {
      const PopupComponent = PopupComponentMapping[variant || PmtOnboardingPopupVariant.TwoPanelCenter];
      return (
        <PopupComponent
          {...popUp}
          onCloseOnboardingPopUp={onCloseOnboardingPopUp}
          onboardingPopUpDelayTime={onboardingPopUpDelayTime}
        />
      );
    }

    return (
      <TwoPanelCenter
        {...popUp}
        onCloseOnboardingPopUp={onCloseOnboardingPopUp}
        onboardingPopUpDelayTime={onboardingPopUpDelayTime}
      />
    );
  };

  return renderPopup();
};
